// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue, { VueConstructor } from 'vue';
import VueResource from 'vue-resource';
import router from '@/router';
import store from '@/store';
import App from '@/app/App.vue';
import Vuelidate from 'vuelidate';
import MultiLanguage from 'vue-multilanguage';

import LanguageEN from '@/languages/en.json';
import LanguageSE from '@/languages/se.json';
import LanguageNO from '@/languages/no.json';
import LanguageIS from '@/languages/is.json';

import Datetime from 'vue-datetime';
import VueNotifications from 'vue-notifications';
import miniToastr from 'mini-toastr';
import CKEditor from "@ckeditor/ckeditor5-vue";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css';

import * as R from 'ramda';
// import "./libs/css/ckeditor.css"
// fix wrong property warning

const toastTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
  warn: 'warn'
};

miniToastr.init({ types: toastTypes });

function toast({ title, message, type, timeout, cb }: {
  title?: string;
  message: string;
  type: keyof typeof toastTypes;
  timeout?: number;
  cb?: () => void;
}) {
  return (miniToastr[type] as (message: string, title?: string, timeout?: number, cb?: () => void) => unknown)(message, title, timeout, cb);
}

const options = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast
};

Vue.use(MultiLanguage, {
  default: 'se',
  en: LanguageEN,
  se: LanguageSE,
  no: LanguageNO,
  is: LanguageIS,
});

Vue.use(CKEditor);
Vue.use(Datetime);
Vue.config.productionTip = false;
Vue.use(VueResource);
Vue.use(R as unknown as { install: (...args: unknown[]) => void });
(window as unknown as { Vue: VueConstructor }).Vue = Vue;
Vue.use(Vuelidate);
Vue.use(VueNotifications, options);

// eslint-disable-next-line no-new
new (Vue as unknown as { new (options: object): Vue })({
  el: '#app',
  store: store,
  router,
  beforeCreate() {
    Object.defineProperty(Vue.prototype, 'R', { value: R });
  },
  beforeMount(this: { language?: string }) {
    // unregister service worker for prevent unused caching for admin part
    if (window.navigator && navigator.serviceWorker) {
      navigator.serviceWorker.getRegistrations()
        .then(function(registrations) {
          for (const registration of registrations) {
            registration.unregister();
          }
        });
    }
    if (!localStorage.langType) {
      localStorage.langType = this.language;
    }
  },
  render: h => h(App),
});
